import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'lib-file-document-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      fill="none"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M14.6666 6.66659V9.99992C14.6666 13.3333 13.3333 14.6666 9.99998 14.6666H5.99998C2.66665 14.6666 1.33331 13.3333 1.33331 9.99992V5.99992C1.33331 2.66659 2.66665 1.33325 5.99998 1.33325H9.33331"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M14.6666 6.66659H12C9.99998 6.66659 9.33331 5.99992 9.33331 3.99992V1.33325L14.6666 6.66659Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M4.66669 8.66675H8.66669"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path
        d="M4.66669 11.3333H7.33335"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round" />
    </svg>
  `,
})
export class FileDocumentIconComponent extends BaseIconComponent {
  override width = input<string>('16');
  override height = input<string>('16');
  override viewBox = input<string>('0 0 16 16');
}
